var _path, _rect, _rect2, _circle, _circle2, _path2, _circle3, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorSearch = function SvgErrorSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 86 108"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.729,
    d: "m73.793 3.972.745-1.738M78.029 6.688l1.431-1.235M80.341 10.719l1.881-.192"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63.398,
    height: 85.773,
    y: 21.138,
    fill: "#F2F2F2",
    rx: 5.967
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 60.898,
    height: 83.273,
    x: 10.946,
    y: 13.438,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2.5,
    rx: 4.717
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.952,
    cy: 39.412,
    r: 1.865,
    fill: "#000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.836,
    cy: 39.412,
    r: 1.865,
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M48.48 55.448a9.3 9.3 0 0 0-.54-3.14 8.4 8.4 0 0 0-1.535-2.661 7.1 7.1 0 0 0-2.299-1.779 6.26 6.26 0 0 0-2.712-.624c-.93 0-1.851.212-2.711.624a7.1 7.1 0 0 0-2.299 1.779 8.4 8.4 0 0 0-1.536 2.661 9.3 9.3 0 0 0-.54 3.14"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.788,
    cy: 84.689,
    r: 16.057,
    fill: "#E6A6B7",
    stroke: "#000",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "m76.324 97.991 8.232 8.232"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.424 91.119a.746.746 0 1 0 1.055 1.055l6.185-6.186 6.186 6.186a.746.746 0 0 0 1.054-1.055l-6.185-6.185 6.185-6.186a.746.746 0 1 0-1.054-1.054l-6.186 6.185-6.185-6.185a.746.746 0 1 0-1.055 1.054l6.185 6.186z"
  })));
};
export default SvgErrorSearch;